/* eslint-disable */
import { Alert, Card, Col, Row, Space } from 'antd';
import { Button } from 'components/atoms/button';
import { OzoneDrawer as Drawer } from 'components/atoms/drawer';
import { useTranslation } from 'hooks/use-translation';
import React, { useState } from 'react';

export const DrawerDemo = () => {
  const view = useTranslation('view');

  const [show, setShow] = useState(false);
  const [showNested, setShowNested] = useState(false);

  return (
    <Space direction="vertical">
      <div>
        <h3> Nested Drawer</h3>
        <Button onClick={() => setShow(!show)}>{view}</Button>

        <Drawer
          visible={show}
          title="title"
          subTitle="subTitle"
          width={1080}
          onClose={() => setShow(!show)}
          footer={<></>}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Card title="Card title" bordered={false}>
                Card content
              </Card>
            </Col>
            <Col span={8}>
              <Card title="Card title" bordered={false}>
                Card content
              </Card>
            </Col>
            <Col span={8}>
              <Card title="Card title" bordered={false}>
                Card content
              </Card>
            </Col>
          </Row>

          <Alert message="Success Text" type="success" />

          <Button onClick={() => setShowNested(!showNested)}>
            Show nested
          </Button>

          <Drawer
            visible={showNested}
            title="Nested Title"
            subTitle="Nested subTitle"
            width={400}
            onClose={() => setShowNested(!showNested)}
            footer={<></>}
          >
            nested
          </Drawer>
        </Drawer>
      </div>
    </Space>
  );
};
